import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useCallback } from "react";
import classnames from "classnames";
import CardArtwork from "@/components/Card/CardArtwork";
import { liveStatus, liveStatusLabel, liveStartDate } from "@/lib/metaUtil";
import { ButtonLink, FavoriteButton } from "@/components/Buttons/index";
import styles from "@/styles/Row.module.scss";
import routes from "@/lib/routes";
var IconCatchup = function IconCatchup(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 0h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0z",
      fill: "#e6e6e6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6 1.8V.4L2.3 2.8 6 5.1V3.8c1.4 0 2.6 1.2 2.6 2.6C8.7 7.8 7.5 9 6 9c-.7 0-1.3-.3-1.8-.8s-.8-1.1-.8-1.8h-2c0 1.2.5 2.4 1.4 3.3.9.8 2 1.3 3.2 1.3 2.5 0 4.6-2.1 4.6-4.6 0-2.6-2-4.6-4.6-4.6z",
      fill: "#1B1E21"
    })]
  }));
};
IconCatchup.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  enableBackground: "new 0 0 12 12",
  xmlSpace: "preserve"
};
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LivePickupListRow(_ref) {
  let {
    item
  } = _ref;
  const handleClick = useCallback(e => {
    if (!item.isAllowedRating) {
      e.preventDefault();
    }
  }, [item]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, styles.pickup, {
      [styles.notAllowed]: !item.isAllowedRating
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.artwork,
        children: /*#__PURE__*/_jsx(CardArtwork, {
          item: item,
          className: styles.artworkInner,
          href: routes.watch(item.id),
          linkAttr: {
            onClick: handleClick
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.info,
        children: [/*#__PURE__*/_jsx("h4", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(VersatileLink, {
            href: routes.watch(item.id),
            children: /*#__PURE__*/_jsx("a", {
              onClick: handleClick,
              children: item.name
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.liveStatus,
          children: [/*#__PURE__*/_jsx("span", {
            className: classnames({
              [styles.onair]: liveStatus(item)
            }),
            children: liveStatusLabel(item)
          }), " ", item.delivery_start_at && /*#__PURE__*/_jsx("span", {
            children: liveStartDate(item)
          }), item.catch_up_flag && /*#__PURE__*/_jsx("span", {
            className: styles.catchupIcon,
            children: /*#__PURE__*/_jsx(IconCatchup, {})
          }), /*#__PURE__*/_jsx("div", {
            className: styles.tags,
            children: /*#__PURE__*/_jsx("span", {
              children: item.genres.map(genre => genre.name).join("/")
            })
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: item.description
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.buttons,
          children: [/*#__PURE__*/_jsx(ButtonLink, {
            fillColor: true,
            medium: true,
            href: routes.watch(item.id),
            disabled: !item.isAllowedRating,
            children: "\u8996\u8074\u3059\u308B"
          }), /*#__PURE__*/_jsx(FavoriteButton, {
            transparent: true,
            borderGray: true,
            favBtnWithLabel: true,
            metaId: item.id,
            text: "\u304A\u6C17\u306B\u5165\u308A"
          })]
        })]
      })]
    })
  });
}